<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__body">
      <tabs>
        <tab id="personal-info" icon="flaticon2-user-1" name="Personal Info">
          <personal-info :sidebar="true" />
        </tab>

        <tab v-if="user.is_admin" id="users"
             v-perms="['multi_user']"
             :icon="'fa fa-users'"
             name="Manage Users">
          <users />
        </tab>

        <tab v-if="user.is_admin && customers_with_users" id="organisation_management"
             :icon="'fa fa-building'"
             name="Manage Organisation">
          <organisation-management />
        </tab>

        <tab v-if="canAccessEmbedThemes()" id="embed_themes"
             v-perms="['embed_themes']"
             :icon="'fa fa-code'"
             name="Embed Themes">
          <embed-themes v-perms="['embed_themes']" />
        </tab>

        <tab id="settings" :icon="'fa fa-cogs'" name="Other Settings">
          <settings />
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import Tab from "VuePartials/App/Preferences/Tab";
import Tabs from "VuePartials/App/Preferences/Tabs";
import Users from "VuePartials/App/Preferences/Tabs/Users";
import PersonalInfo from "VuePartials/App/Preferences/Tabs/PersonalInfo";
import Settings from "VuePartials/App/Preferences/Tabs/Settings";
import OrganisationManagement from "VuePartials/App/Preferences/Tabs/OrganisationManagement";
import EmbedThemes from "VuePartials/App/Preferences/Tabs/EmbedThemes";
import Unauthorised from "VuePartials/App/Unauthorised";

Vue.component("unauthorised", Unauthorised);

export default {
  name: "Preferences",
  components: {
    Tab,
    Tabs,
    Users,
    PersonalInfo,
    Settings,
    OrganisationManagement,
    EmbedThemes,
  },
  data: () => ({
    user: window.user,
    customers_with_users: window.customers_with_users,
  }),

  methods: {
    canAccessEmbedThemes() {
      return _.includes(_.map(window.customer_plan_features, 'slug'), 'embed_themes');
    },
  },
};
</script>
